module.exports = __webpack_public_path__ + "img/Invite.d4d5db5b.png";